import React from 'react'
import { useTranslation } from 'next-i18next'
import { FREQUENCY } from '@classy/campaign-page-blocks'
import Row from 'modules/ui/atoms/Layout/Row'
import { LabelDiv, Spacer, ValueDiv } from './thank-you-step.styled'
import useConfig from 'modules/config/state/use-config'
import useOrder from 'modules/order/state/order/use-order'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import { getFrequencyLabel } from 'utils/functions/frequencyUtils'
import { getCurrencyDecimalPlaces } from '../../../../utils/currency'

const ThankYouStepContent = () => {
  const { t } = useTranslation('common')
  const config = useConfig()
  const order = useOrder()

  const { confirmationId } = useSelector((state: RootState) => state.order.transaction)

  const amount = order.dcf.value.isChecked
    ? order.amount.value + order.dcf.value.fee
    : order.amount.value

  return (
    <>
      <Row style={{ alignItems: 'center', paddingBottom: '20px' }}>
        {config?.thankYouMessage?.message ||
          t('thankYouStepContent.donationMessage.default', 'Thank you for your donation!')}
      </Row>

      <Row style={{ alignItems: 'center', paddingBottom: '20px' }}>
        {t(
          'thankYouStepContent.emailInfo',
          'We will be sending a donation receipt to {{email}} shortly.',
          {
            email:
              order.contact.value.email || t('thankYouStepContent.emailPlaceholder', 'your email'),
          },
        )}
      </Row>

      <Row style={{ alignItems: 'center', padding: '4px 0px 16px 0px' }}>
        <LabelDiv className="label">{t('thankYouStepContent.amount.label', 'Amount')}</LabelDiv>
        <Spacer className="spacer"></Spacer>
        <ValueDiv className="value">
          {amount.toFixed(getCurrencyDecimalPlaces(order.currency.value))} {order.currency.value}
        </ValueDiv>
      </Row>

      <Row style={{ alignItems: 'center', padding: '4px 0px 16px 0px' }}>
        <LabelDiv className="label">
          {t('thankYouStepContent.frequency.label', 'Frequency')}
        </LabelDiv>
        <Spacer className="spacer"></Spacer>
        <ValueDiv className="value">{getFrequencyLabel(order.frequency.value)}</ValueDiv>
      </Row>

      {order.frequency.value !== FREQUENCY.ONE_TIME && !!order.recurringEndDate.value && (
        <Row style={{ alignItems: 'center', padding: '4px 0px 16px 0px' }}>
          <LabelDiv className="label">
            {t('thankYouStepContent.endDate.label', 'End Date')}
          </LabelDiv>
          <Spacer className="spacer"></Spacer>
          <ValueDiv className="value">{order.recurringEndDate.value}</ValueDiv>
        </Row>
      )}

      <Row style={{ alignItems: 'center', padding: '4px 0px 16px 0px' }}>
        <LabelDiv className="label">
          {t('thankYouStepContent.confirmationId.label', 'Confirmation ID')}
        </LabelDiv>
        <Spacer className="spacer"></Spacer>
        <ValueDiv className="value">{confirmationId}</ValueDiv>
      </Row>
    </>
  )
}

export default ThankYouStepContent
